import { transport } from 'config/transport';

export function callApiExportThuDauNam(classId) {
    return transport.get(`/mamnon/thuhocsinh/thudaunam/export/${classId}`, { responseType: 'blob' });
}
